import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { trackAddToCart } from '../lib/metaPixel';
const handleAddToCart = () => {
  trackAddToCart({
    value: 6.36,
    currency: 'USD',
    content_name: 'El Método de los 90 Segundos',
    content_ids: ['metodo-90-segundos'],
    content_type: 'product'
  });
};
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-211">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-brand-navy/10 shadow-[0_-10px_30px_rgba(0,0,0,0.05)] z-50 md:hidden" data-id="element-212">
          <div className="flex items-center justify-between gap-4 max-w-md mx-auto" data-id="element-213">
            <div className="font-bold text-brand-navy text-lg" data-id="element-214">
              $6,36{' '}
              <span className="text-xs font-normal text-brand-navy/60" data-id="element-215">
                USD
              </span>
            </div>
            <Button href="https://ofertavital.com/cart/43932888203329:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="py-3 px-6 flex-1 text-base" data-id="element-216">
              Comprar ahora
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}